module.exports = __webpack_public_path__ + "fonts/es_ES_7b5666a783b4c2193c42218e365f7e75.svg";